import Box from '@mui/material/Box'
import Switch from '@mui/material/Switch'
import { reExportedColors } from './index'

const SwitchBase = ({ checked, onChange, className }) => {
  const thumb = (
    <Box
      className='MuiSwitch-thumb'
      component='span'
      sx={{
        background: 'primary.accent',
        borderRadius: '50%',
        boxShadow: 'none',
        height: 16,
        width: 16
      }}
    />
  )

  return (
    <Switch
      checked={checked}
      checkedIcon={thumb}
      className={className}
      icon={thumb}
      onChange={onChange}
      sx={{
        padding: '12px 8px',
        width: 42,
        '&& .MuiSwitch-track': {
          background: `${reExportedColors.GREY1} !important`,
          border: `1px solid ${reExportedColors.GREY2} !important`,
          opacity: '1 !important'
        },
        '&& .MuiSwitch-switchBase': {
          bottom: '0 !important',
          left: '-2px !important',
          margin: 'auto !important',
          top: '0 !important'
        },
        '&& .MuiIconButton-root:hover': { background: 'none' },
        '&& .MuiSwitch-switchBase.Mui-checked': {
          transform: 'translateX(12px) !important'
        }
      }}
    />
  )
}

export default SwitchBase
